<ecp-workflow [customConfig]="customConfig"></ecp-workflow>
